import { ExtendedLink } from './link'

export * from './link'

export default ExtendedLink